import React, { useState, useEffect } from "react";
import DropDown from "../Select";
import "./Popup.scss";
import Buildings from "../../assets/images/buildings.svg";
import axios from "../../redux/axios";
import { useSelector, useDispatch } from "react-redux";
import { areaValue, cityValue, clearTest } from "../../redux/auth/actions";
import { useHistory } from "react-router-dom";
import Closeicon from "../../../src/assets/images/SheetClose.svg";
import info from "../../assets/images/infoIcon.svg";
import idea from "../../assets/images/idea1.svg";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

function Popup(props) {
  const [city, setcity] = React.useState([]);
  const [areaList, setAreaList] = React.useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [area, setArea] = React.useState([]);
  const [areaVal, setAreaVal] = useState();
  const [errStat, setErrStat] = useState(false)
  const [cityName, setCityName] = useState("")
  const [selectedAreaData, setselectedAreaData] = useState({
    label: undefined,
    name: "",
    value: ""
  });
  const [duplicatesarea, setDuplicateArea] = useState({
    label: undefined,
    value: ""
  })
  const [duplicatesarea1, setDuplicateArea1] = useState({
    label: undefined,
    name: "",
    value: ""
  });
  const selected_test = useSelector(
    (state) => state.selected_test.selected_test
  );
  const cities = useSelector((state) => state.auth.cities);


  const cityState = useSelector((state) =>
    state.city != undefined && state.city.label != undefined ? state.city : ""
  );
  const areaState = useSelector((state) =>
    state?.area != undefined && state?.area?.area?.label != undefined
      ? state.area.area
      : ""
  );

  const [duplicatesarea2, setDuplicateArea2] = useState({
    label: '',
    name: "",
    value: ""
  });


  const state = useSelector((state) => state);
  const [mobileView, setMobileView] = useState(false);
  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 767
        ? setMobileView(true)
        : setMobileView(false);
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);
  const [arValue, setArValue] = React.useState();
  const [data, setData] = React.useState({ data: [], homeservice: "yes" });
  const [recity, setRecity] = React.useState([]);
  const dispatch = useDispatch();
  const history = useHistory();

  React.useEffect(() => {
    if (cities) {
      let res = cities.map((e, i) => {
        return {
          label: e.name?.replace(/_/g, ' ')
            .replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()), value: e.uuid
        };
      });
      setcity(res);
      axios
        .get(`${process.env.REACT_APP_API_URL}/uploadDoc/getArea/${duplicatesarea?.value}`)
        .then((res) => {
          setAreaList(res.data);
          console.log(res.data);
        });
    }

  }, [props, props.city]);

  React.useEffect(() => {
    if (areaList && areaList.length !== 0) {
      let res = areaList.map((e, i) => {
        return {
          label: e.name?.replace(/_/g, ' ')
            .replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()), value: e.uuid
        };
      });
      setArea(res);
    }
  }, [areaList]);

  const handlearea = (city) => {
    // setArValue(null);
    const { value, label } = city;
    // dispatch(cityValue({ value, label }));
    axios
      .get(`${process.env.REACT_APP_API_URL}/uploadDoc/getArea/${value}`)
      .then((res) => {
        setAreaList(res.data);
        console.log(res.data);
      });
  };

  React.useEffect(() => {
    if (selected_test && selected_test.length !== 0) {
      let res = [];
      selected_test.map((v, i) => {
        v && v.doc && v.doc.testname_uuid && v.doc.testname_uuid !== undefined
          ? res.push({
            test_type:
              v.doc.testname_uuid.slice(0, 2) === "LP"
                ? "pathology"
                : v.doc.testname_uuid.slice(0, 2) === "LR"
                  ? "radiology"
                  : v.doc.testname_uuid === undefined
                    ? "biochecks"
                    : "nodata",
            testname_uuid: v.doc.testname_uuid,
            areaRef: v.doc.areaRef,
          })
          : res.push({
            test_type: "biochecks",
            uuid: v.doc.uuid,
          });
      });

      setData({
        data: res,
        homeservice: "yes",
      });
    }
  }, [selected_test]);

  React.useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/order/diagnostic/mostCity`)
      .then((res) => setRecity(res.data.data))
      .catch((err) => console.log(err.response));
  }, []);

  // const handlePopularCities = (event) => {
  //   console.log(event);
  //   let values = {
  //     label: event.name,
  //     name: "",
  //     value: event.uuid,
  //   };
  //   setAreaVal(values);
  //   console.log(values, "555");
  //   handlearea(values);
  // };


  const [areavalue, setAreaValue] = useState('')


  const handleCity = (ev, selectedCity) => {
    // let value = selectedCity.value;
    // let label = selectedCity.label;

    let values = {
      label: selectedCity?.label,
      name: '',
      value: selectedCity?.value,
    };
    setCityName(values)

    // dispatch(cityValue({ value: values.value, label: values.label }));
    axios
      .get(`${process.env.REACT_APP_API_URL}/uploadDoc/getArea/${values.value}`)
      .then((res) => setAreaList(res.data));
    setselectedAreaData({ ...selectedAreaData, value: "", label: "" })
    setDuplicateArea1({ ...duplicatesarea1, value: '', label: '' })

  };




  const handlePopularCities = (event) => {
    console.log(event)
    let values = {
      label: event.name,
      name: '',
      value: event.uuid,
    };
    setAreaVal(values);
    console.log(values, "555")
    handlearea(values);
    // dispatch(cityValue(values));

    setArValue('Select Area')
    setCityName(values)
    setselectedAreaData({ ...selectedAreaData, value: "", label: "" })
    setDuplicateArea1({ ...duplicatesarea1, value: '', label: '' })

    // dispatch(areaValue())

  };


  const HandleAreaSelect = (ev, selectedArea) => {
    console.log(selectedArea, "selectedArea")
    setArValue(ev.target);
    setAreaValue(selectedArea === null ? "" : selectedArea)
  }



  const handleAreaNew = (ev, selectedArea) => {
    dispatch(clearTest());
    setArValue(ev.target);
    setDuplicateArea(selectedArea)
    setDuplicateArea1({
      ...duplicatesarea1, value: selectedArea?.value, label: selectedArea?.label?.replace(/_/g, ' ')
        .replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
    })
  };
  const confirmArea = () => {
    dispatch(cityValue({ value: cityName.value, label: cityName.label }));
    setselectedAreaData({ ...selectedAreaData, value: duplicatesarea?.value, label: duplicatesarea?.label })
  }
  useEffect(() => {

    if (selectedAreaData.value !== "") {

      dispatch(areaValue(selectedAreaData));
      // dispatch(clearTest());
      // props.handleLocationChange();
    }
  }, [selectedAreaData])

  const closePopup = () => {
    setShowPopup(false);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const phoneNumber = "+2349010996000";
  const boldStyle = {
    fontWeight: 'bold',
    cursor: "grab",
    color: "#ff5c3c",
    fontSize: "15px"
  };

  const handleWhatsAppClick = (event) => {
    console.log(event, "click on the whatsapp num")
    const formattedPhoneNumber = phoneNumber.replace(/\D/g, ''); // Remove any non-numeric characters
    const whatsappLink = `https://api.whatsapp.com/send?phone=${formattedPhoneNumber}`;
    window.open(whatsappLink, '_blank');
  };

  return (
    <>
      {/* {!mobileView && 
          <div className="parentContainer2">
          <div className="popuphead5">Confirm/Select Location</div>
          <div
            style={{ cursor: "pointer" }}
            className="labmodal_close"
            onClick={() => {
              props.setShowLocation();
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 15L15 1M1 1L15 15L1 1Z"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          {!mobileView ? (
            <div className="inform_container">
              <img src={info} alt="icon" />
              If your city and area are not available, it means that we cannot
              provide the service to you. We will keep you informed and be coming
              to your area shortly. You can also select a location closest to you.
            </div>
          ) : (
            <div className="tips_container">
              <div className="heading_container">
                <img src={idea} alt="icon" />
                <div className="heading">Help Tip</div>
              </div>
              <div className="txt">
                If your city and area are not available, it means that we cannot
                provide the service to you. We will keep you informed and be
                coming to your area shortly. You can also select a location
                closest to you.
              </div>
            </div>
          )}
          <div className="drop">
            <div style={{ marginRight: "25px" }}>
              <DropDown
                placeholder={"Select City"}
                onChange={(e) => {
                  handlearea(e.target);
                  // console.log(e.target,"sss")
                  setAreaVal(e.target);
                }}
                value={areaVal}
                options={city && city.length !== 0 ? city : []}
                arrowStyle={{
                  background: "#9CA3AF",
                }}
              />
            </div>
            <div className="sec">
              <DropDown
                placeholder={"Select Area"}
                onChange={(e) => {
                  dispatch(clearTest());
                  setArValue(e.target);
                  dispatch(areaValue(e.target));
                }}
                setValue={(value) => console.log(value)}
                options={area && area.length !== 0 ? area : []}
                arrowStyle={{
                  background: "#9CA3AF",
                }}
              />
            </div>
          </div>
          {recity && recity.length !== 0 ? (
            <>
              <div className="recent">RECENTLY SEARCHED CITIES</div>
              <div className="citiesparent">
                {recity.map((v, i) =>
                  v.city.map((value, index) => {
                    return (
                      <div
                        className="cities"
                        key={index}
                        onClick={() => handlePopularCities(value)}
                        style={{ cursor: "pointer" }}
                      >
                        <img src={Buildings} alt="building" />
                        <span
                          className="popular-city"
                          onClick={() => handlePopularCities(value)}
                        >
                          {value.name}
                        </span>
                      </div>
                    );
                  })
                )}
              </div>
            </>
          ) : (
            ""
          )}
          {props.type === "landingPage" ? (
            arValue && arValue.value !== undefined ? (
              <div
                className="popup_btn"
                style={
                  arValue && arValue.value !== undefined ? {} : {} //opacity: "0.5", cursor: "not-allowed"
                }
                onClick={() => {
                  props.onHide();
                }}
              >
                Continue
              </div>
            ) : (
              <div
                className="popup_btn"
                style={
                  arValue && arValue.value !== undefined
                    ? {}
                    : { backgroundColor: "blue" } //opacity: "0.5", cursor: "not-allowed"
                }
                onClick={() => {
                  props.onHide();
                }}
              >
                Cancel
              </div>
            )
          ) : (
            <div
              className="popup_btn"
              style={
                arValue && arValue.value !== undefined
                  ? {}
                  : { opacity: "0.5", cursor: "not-allowed" }
              }
              onClick={() => {
                props.setShowLocation(false);
                props.setArea(arValue.value);
              }}
            >
              Proceed to Compare Prices
            </div>
          )}
        </div>
    } */}
      {/* { mobileView && */}
      <div className="parentContainer" >

        <div className="popuphead5">Confirm/Select Location
          {/* <img alt="icon" src={Closeicon}  onClick={() => {props.setShowLocation(false);}} /> */}
          {/* {(props.view && (
            <img alt="icon" src={Closeicon} onClick={() => props.onClose(false)} />
          )) ||
            ""} */}
          {(props.view && (
            <img alt="icon" src={Closeicon} onClick={() => props.onClose(false)} />
          )) ||
            ""}
        </div>



        {mobileView &&
          <div
            style={{ cursor: "pointer" }}
            className="labmodal_close"

            onClick={() => {
              // props.view(false);
              // props.close(false)
              // props.onClose(false)
              // props?.setAddressChangePopUp();
              // props.setLocationChangeError();
              props.type === "landingPage" ?
                props.onHide()
                :
                props.setShowLocation(false);
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 15L15 1M1 1L15 15L1 1Z"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        }
        {!mobileView &&
          <div
            style={{ cursor: "pointer" }}
            className="labmodal_close"

            onClick={() => {
              // props.view(false);
              // props.close(false)
              // props.onClose(false)
              props.type === "landingPage" ?
                props.onHide()
                :
                props?.setShowLocation(false);
              // props?.setAddressChangePopUp();
              // props?.setLocationChangeError();
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 15L15 1M1 1L15 15L1 1Z"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        }

        {/* <div
          style={{ cursor: "pointer" }}
          className="labmodal_close"
          onClick={() => {
            props.onHide();
            // props.setShowLocation(false)
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 15L15 1M1 1L15 15L1 1Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div> */}
        {!mobileView ? (
          <div className="inform_container">
            <img src={info} alt="icon" />
            <p>
              If your city or area is currently unavailable, it means that we are unable to provide our services to you at this time. However, we will keep you informed and make efforts to expand our service to your location in the near future. In the meantime, you have the option to select the closest available location or contact our team via WhatsApp at{''}<a target="" onClick={handleWhatsAppClick} style={boldStyle}>{phoneNumber}</a> for assistance.
            </p>
          </div>
        ) : (
          <div className="tips_container">
            <div className="heading_container">
              <img src={idea} alt="icon" />
              <div className="heading">Help Tip</div>
            </div>
            <div className="txt">
              <p>
                If your city or area is currently unavailable, it means that we are unable to provide our services to you at this time. However, we will keep you informed and make efforts to expand our service to your location in the near future. In the meantime, you have the option to select the closest available location or contact our team via WhatsApp at{''}<a target="" onClick={handleWhatsAppClick} style={boldStyle}>{phoneNumber}</a> for assistance.
              </p>
              {/* If your city or area is currently unavailable, it means that we are unable to provide our services to you at this time. However, we will keep you informed and make efforts to expand our service to your location in the near future. In the meantime, you have the option to select the closest available location or contact our team via WhatsApp at <span style={{ cursor: "grab", color: "#ff5c3c", fontSize: "15px" }}>+2349010996000</span> for assistance.</p> */}
            </div>
          </div>
        )}
        <div className="drop">
          <div style={{ marginRight: "25px" }}>
            {/* <DropDown
              placeholder={"Select City"}
              onChange={(e) => {
                handlearea(e.target);
                console.log(e.target, "555");
                setAreaVal(e.target);
                setArValue(null);
                // dispatch(areaValue(null));
              }}
              value={areaVal}
              options={city && city.length !== 0 ? city : []}
              arrowStyle={{
                background: "#9CA3AF",
              }}
            /> */}

            <Autocomplete
              // value={cityName ? cityName : cityState}
              value={cityName.label === undefined ? cityState : cityName}
              id="grouped-demo"
              options={city}
              defaultValue={cityState}
              // getOptionLabel={(option) => option.label}
              sx={{ width: 300 }}
              renderInput={(params) => <TextField {...params}
                placeholder={"Select City"}
              />
              }
              onChange={handleCity}
            />
          </div>

          <div className="sec">
            {/* <DropDown
              placeholder={"Select Area"}
              onChange={(e) => {
                dispatch(clearTest());
                setArValue(e.target);
                console.log(e.target,"fddgdfdfdg")
                dispatch(areaValue(e.target));
              }}
              value={arValue}
              options={area && area.length !== 0 ? area : []}
              arrowStyle={{
                background: "#9CA3AF",
              }}
            /> */}
            {/* areaState?.label === '' || areaState?.label === undefined ? duplicatesarea2 : areaState */}
            <Autocomplete
              id="grouped-demo1"
              // value={areaState?.value === undefined ? "" : areaState}
              options={area}
              // groupBy={(option) => option.firstLetter}
              getOptionLabel={(option) => option?.label?.replace(/_/g, ' ')
                .replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()) === "Wuse Ii" ? "Wuse II" : option?.label?.replace(/_/g, ' ')
                  .replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())}
              sx={{ width: 300 }}
              renderInput={(params) => <TextField {...params}
                // label="With categories" 
                placeholder={"Select Area"}

              />
              }
              onChange={handleAreaNew}
              // onChange={HandleAreaSelect}
              value={duplicatesarea1?.label !== undefined ? duplicatesarea1 : areaState?.label === undefined || areaState === '' ? duplicatesarea2 : areaState}
            // value={duplicatesarea1?.label === '' ? duplicatesarea2 : duplicatesarea1 || duplicatesarea1?.label === undefined ? areaState : duplicatesarea2}
            // defaultValue={selectedAreaData?.value ? selectedAreaData : areaState}
            // onSelect={(event) => handlearea2(event)}

            />
            {errStat === true &&
              <p style={{ color: "red" }}>State Cannot be empty</p>
            }

          </div>
        </div>
        {recity && recity.length !== 0 ? (
          <>
            <div className="recent">RECENTLY SEARCHED CITIES</div>
            <div className="citiesparent">
              {recity.map((v, i) =>
                v.city.map((value, index) => {
                  console.log(value);
                  return (
                    <div
                      className="cities"
                      key={index}
                      onClick={() => handlePopularCities(value)}
                      style={{ cursor: "pointer" }}
                    >
                      <img src={Buildings} alt="building" />
                      <span
                        className="popular-city"
                        onClick={() => {
                          handlePopularCities(value);
                        }}
                      >
                        {value.name?.replace(/_/g, ' ')
                          ?.replace(/\w\S*/g, txt => txt?.charAt(0)?.toUpperCase() + txt?.substr(1)?.toLowerCase())}
                      </span>
                    </div>
                  );
                })
              )}
            </div>
          </>
        ) : (
          ""
        )}
        <div className="row" style={{ display: "flex", justifyContent: "space-around", alignItems: "center" }}>
          {props.type === "landingPage" ? (
            <>
              {((cityName === {} || cityName?.label === undefined) && (duplicatesarea1?.label === undefined || duplicatesarea1?.label === "")) ?
                <button className="popup_btn col-12 col-md-6" style={{ cursor: "no-drop" }} disabled> Confirm</button>
                :
                <div
                  className="popup_btn col-12 col-md-6"
                  style={
                    (duplicatesarea1?.label === undefined || duplicatesarea1?.label === "" || cityName?.label === undefined || cityName?.label === "") ? { opacity: "0.5", cursor: "not-allowed" } : {}
                    // arValue && arValue.value !== undefined ? {} : {} //opacity: "0.5", cursor: "not-allowed"
                  }
                  onClick={() => {
                    props.type === "landingPage" ? props.onHide() :
                      props?.setShowLocation(false);
                    confirmArea()
                    // handleAreaNew()
                    // props?.setArea(arValue.value);
                    // history.push({ pathname: "/compareprice", state: data });
                  }}
                >
                  Confirm
                </div>
              }
              <div
                className="popup_btn col-12 col-md-6"
                style={
                  arValue && arValue.value !== undefined
                    ? {}
                    : { backgroundColor: "blue" } //opacity: "0.5", cursor: "not-allowed"
                }
                onClick={() => {
                  // props.onHide();
                  props.type === "landingPage" ? props.onHide() : props.setShowLocation(false);
                }}
              >
                Cancel
              </div>
            </>
            // arValue && arValue.value !== undefined ? (
            //   <div
            //     className="popup_btn col-12 col-md-6"
            //     style={
            //       arValue && arValue.value !== undefined ? {} : {} //opacity: "0.5", cursor: "not-allowed"
            //     }
            //     onClick={() => {
            //       props.setShowLocation(false);
            //       props.setArea(arValue.value);
            //       // history.push({ pathname: "/compareprice", state: data });
            //     }}
            //   >
            //     Confirm
            //   </div>
            // ) : (
            //   <div
            //     className="popup_btn col-12 col-md-6"
            //     style={
            //       arValue && arValue.value !== undefined
            //         ? {}
            //         : { backgroundColor: "blue" } //opacity: "0.5", cursor: "not-allowed"
            //     }
            //     onClick={() => {
            //       // props.onHide();
            //       props.setShowLocation(false);
            //     }}
            //   >
            //     Cancel
            //   </div>
            // )
          ) : (
            <>
              <div
                className="popup_btn col-12 col-md-6"
                style={
                  // (arValue && arValue.value !== undefined || area !== "")
                  //   ? {}
                  //   : { opacity: "0.5", cursor: "not-allowed" }
                  (duplicatesarea1?.label === undefined || duplicatesarea1?.label === "" || cityName?.label === undefined || cityName?.label === "") ? { opacity: "0.5", cursor: "not-allowed" } : {}
                }
                onClick={() => {
                  if (duplicatesarea1?.label !== undefined && duplicatesarea1?.label !== "" && cityName?.label !== undefined && cityName?.label !== "") {
                    props?.setShowLocation(false);
                    props?.setArea(arValue?.value);
                    confirmArea();
                    // history.push({ pathname: "/compareprice", state: data });
                  }
                }}
              >
                Set Location
              </div>
              <div
                className="popup_btn col-12 col-md-6"
                style={
                  arValue && arValue.value !== undefined
                    ? {}
                    : { backgroundColor: "blue" } //opacity: "0.5", cursor: "not-allowed"
                }
                onClick={() => {
                  // props.onHide();
                  props.setShowLocation(false);
                }}
              >
                Cancel
              </div>

            </>
          )}
        </div>
      </div >
      {/* // } */}
    </>
  );
}

export default Popup;
